import React, { useState } from "react";
import { Card, Table, Button, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpload, faLink } from "@fortawesome/free-solid-svg-icons";

const DocumentSection = ({ data, setShowCanvas, setDocumentModel, status }) => {
  const [viewer, setViewer] = useState({
  show: false,
  path: "",
  extension: "",
  status: "",
  id: null,
});
const handleAccept = (id) => {
  console.log("Accepted document with ID:", id);
  // Call API or dispatch mutation
};

const handleReject = (id) => {
  console.log("Rejected document with ID:", id);
  // Open modal for reason or call API directly
};

  const handleView = (path, extension, status, id) => {
    setViewer({ show: true, path, extension, status, id });
  };

  if (data?.status === "PendingApproval") return null;

  const canUploadDocument = data?.status === "Accepted";

  return (
    <div className="col-md-12">
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="py-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="m-0">Documents : </h6>
            {canUploadDocument && (
              <Button variant="primary" className="btn-sm">
                <FontAwesomeIcon icon={faPlus} /> Add Document
              </Button>
            )}
          </div>
          <Table
            responsive
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0 text-center">#</th>
                <th className="border-0 text-center">Document Title</th>
                <th className="border-0 text-center">Status</th>
                <th className="border-0 text-center">Uploaded By</th>
                <th className="border-0 text-center">Who Can Upload</th>
                <th className="border-0 text-end pe-4">Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.loadDocuments?.length > 0 ? (
                data.loadDocuments.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center align-middle">{index + 1}</td>
                    <td className="fw-bold align-middle text-center">
                      {item.documentType || "-"}
                    </td>
                    <td className="align-middle text-center">
                      {status(item.status)}
                    </td>
                    <td className="align-middle text-center">
                      {item.uploaderName || "-"}
                    </td>
                    <td className="align-middle text-center">
                      {item.whoCanUpload == null
                        ? "Both"
                        : item.whoCanUpload === "None"
                        ? "Admin"
                        : item.whoCanUpload}
                    </td>
                    <td className="text-center align-middle">
                      {item.documentPath ? (
                        <div className="d-flex gap-2 justify-content-center">
                          <Button
                            className="btn btn-info btn-sm"
                            style={{ minWidth: 70 }}
                            onClick={() =>
    handleView(item.documentPath, item.extention, item.status, item.id)
  }
                          >
                            View
                          </Button>
                          <button
                            className="btn btn-warning btn-sm"
                            style={{ minWidth: 70 }}
                            onClick={() =>
                              item.documentType === "Bilty"
                                ? setShowCanvas(true)
                                : setDocumentModel({
                                    show: true,
                                    title: `${item.documentType}`,
                                    type: item.id,
                                  })
                            }
                          >
                            Update
                          </button>
                        </div>
                      ) : item.documentType === "Bilty" ? (
                        <button
                          style={{ minWidth: 150 }}
                          className="btn btn-success btn-sm align-items-center"
                          onClick={() => setShowCanvas(true)}
                        >
                          <FontAwesomeIcon className="me-1" icon={faLink} />{" "}
                          Assign Bilty
                        </button>
                      ) : (
                        <button
                          className="btn btn-success btn-sm"
                          style={{ minWidth: 150 }}
                          onClick={() =>
                            setDocumentModel({
                              show: true,
                              title: `Upload ${item.documentType}`,
                              type: item.documentType,
                            })
                          }
                        >
                          <FontAwesomeIcon className="me-1" icon={faUpload} />{" "}
                          Upload {item.documentType}
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <Offcanvas
        className="w-75"
        show={viewer.show}
        onHide={() => setViewer({ show: false, path: "", extension: "" })}
        placement="end"
        scroll
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Document Preview</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            {viewer.status === "Uploaded" && (
  <div className="mt-3 d-flex gap-2 justify-content-end">
    <Button
      variant="success"
      onClick={() => handleAccept(viewer.id)}
      size="sm"
    >
      Accept
    </Button>
    <Button
      variant="danger"
      onClick={() => handleReject(viewer.id)}
      size="sm"
    >
      Reject
    </Button>
  </div>
)}

          {viewer.extension === ".pdf" ? (
            <iframe
              src={viewer.path}
              width="100%"
              height="600px"
              style={{ border: "none" }}
              title="PDF Viewer"
            />
          ) : viewer.extension.match(/\.(png|jpg|jpeg|webp)$/i) ? (
            <img
              src={viewer.path}
              alt="Document Preview"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          ) : (
            <p>Unsupported file type: {viewer.extension}</p>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default DocumentSection;
